import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useSecurityStore = defineStore('security', () => {
  const accessToken = ref(null)

  return { accessToken}
})
